import {css} from "lit";



export const chNavItemStyles = css` 

    div {
        display: flex;
        flex-direction: row;
        gap: var(--sbkSubNavItemSpacingGapIconLink);
        height: var(--sbkSubNavItemSizingMaxHeight);
        align-items: center;
        border-bottom: var(--sbkSubNavItemBorderDefault);
        padding: var(--sbkSubNavItemSpacingInsetTop) var(--sbkSubNavItemSpacingListInsetRight) var(--sbkSubNavItemSpacingInsetBottom) 0;
        box-sizing: border-box;

        &.nav-item--active {
            border-bottom: var(--sbkSubNavItemBorderSelected);

            sbk-link::part(link) {
                color: var(--sbkLinkFgColorOnLightSelected);
            }

            img {
                filter: brightness(0) saturate(100%) invert(25%) sepia(91%) saturate(1680%) hue-rotate(174deg) brightness(91%) contrast(85%);
            }
        }
    }
    
    img.hovered {
        filter: brightness(0) saturate(100%) invert(34%) sepia(56%) saturate(458%) hue-rotate(164deg) brightness(101%) contrast(83%);
    }
`;